import { get, isAPIError } from '@user/store/services/crud'
import { urls } from '../constants'
import { toast } from '@sales-center/components'
import { fetchAllActivities } from '../state'
import type { ENTITY_TYPES } from '@sales-center/common'

export async function fetchAllActivitiesEffect(
  entityId: number,
  entityType: ENTITY_TYPES,
) {
  const response = await get(urls.fetchAll(entityId, entityType))
  const result = await response.json()

  if (!response.ok) {
    if (isAPIError(result.payload)) {
      toast.error(result.payload.Message)
    } else {
      toast.error('Failed to fetch Activities')
    }
    return fetchAllActivities([])
  }

  return fetchAllActivities(result)
}
